import { jsx as r } from "react/jsx-runtime";
import { memo as i } from "react";
let e = !1;
const u = (t) => i((n) => {
  const o = n.singleTon;
  return e && o ? null : (e = !0, /* @__PURE__ */ r(t, { ...n }));
});
export {
  u as default
};
//# sourceMappingURL=withSingleton.es.js.map
